async function handleGiftAddToCart(redirectToCheckout) {

  const checked = document.querySelectorAll('.gift-addon-checkbox:checked');
  const error = document.querySelector('.gift-addon-error');

  if (checked.length < 3) {
    if (error) {
      error.style.display = 'block';
      error.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return;
  }

  if (error) error.style.display = 'none';

  const quantityInput = document.querySelector('input[name="quantity"]');
  const quantity = quantityInput ? parseInt(quantityInput.value) : 1;
  const variant = document.querySelector('input[name="id"]').value;
  const bundleId = 'gift_' + Date.now() + '_' + Math.random().toString(36).slice(2, 7);

  const items = [];

  items.push({
    id: variant,
    quantity: quantity,
    properties: {
      _bundle: 'gift-box',
      _bundle_id: bundleId
    }
  });

  checked.forEach(function (el) {
    items.push({
      id: el.dataset.variantId,
      quantity: quantity,
      properties: {
        _addon: 'true',
        _bundle_id: bundleId
      }
    });
  });

  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items })
  });

  if (redirectToCheckout) {
    window.location = '/checkout';
  } else {
    window.location = '/cart';
  }
}

// Add to Cart button
document.addEventListener('click', async function (e) {

const addBtn = e.target.closest('button[name="add"]');
  if (addBtn) {
    const hasAddons = document.querySelector('.gift-addon-checkbox');
    if (!hasAddons) return;

    // Only intercept if this button is on a gift box product page
    // gift-addon-checkbox exists only on gift box product pages
    e.preventDefault();
    e.stopImmediatePropagation();

    const checked = document.querySelectorAll('.gift-addon-checkbox:checked');

    const error = document.querySelector('.gift-addon-error');
    if (checked.length < 3) {
      if (error) {
        error.style.display = 'block';
        error.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }

    if (error) error.style.display = 'none';
    addBtn.disabled = true;
    await handleGiftAddToCart(false);
    return;
  }

const buyNowBtn = e.target.closest('#gift-buy-now');
  if (buyNowBtn) {
    const checked = document.querySelectorAll('.gift-addon-checkbox:checked');

    const error = document.querySelector('.gift-addon-error');
    if (checked.length < 3) {
      if (error) {
        error.style.display = 'block';
        error.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }

    if (error) error.style.display = 'none';
    buyNowBtn.disabled = true;
    buyNowBtn.textContent = 'Processing...';
    await handleGiftAddToCart(true);
    return;
  }

});

function hideGiftBoxCardButtons() {
  document.querySelectorAll('product-card.gift-box-card').forEach(function (card) {
    var buyButtons = card.querySelector('.buy-buttons-block, add-to-cart-component, .quick-add');
    if (buyButtons) buyButtons.style.display = 'none';
  });
}
hideGiftBoxCardButtons();
if (window.MutationObserver) {
  new MutationObserver(hideGiftBoxCardButtons).observe(document.body, { childList: true, subtree: true });
}